export enum DisputesHistoryDialogFormControlNamesEnum {
  DISPUTE_NUMBER = 'DisputeId',
  CURRENT_STATUS = 'CurrentStatus',
  LAST_UPDATED_DATE = 'LastUpdatedBy',
  LAST_UPDATED_BY = 'LastUpdatedDate',
}
